/**
 * Account-level settings, stored per Group (an agency's account) in `group.settings`.
 *
 * Stored values are partial: a setting nobody has changed isn't stored, so `resolveAccountSettings`
 * (@shared/utils) fills in these defaults and the default can change without a migration.
 */

/**
 * How long an archived project's documents are kept before deletion. `null` means never. Spelled
 * out rather than derived from the choices below, so TSOA can describe it in the API spec.
 */
export type TDocumentRetentionChoice = 30 | 60 | 90 | 180 | 365;
export type TDocumentRetentionDays = TDocumentRetentionChoice | null;
export const DOCUMENT_RETENTION_DAY_CHOICES: readonly TDocumentRetentionChoice[] =
  [30, 60, 90, 180, 365];

export type TAccountSettings = {
  documentRetentionDays: TDocumentRetentionDays;
};

export const ACCOUNT_SETTING_DEFAULTS: TAccountSettings = {
  documentRetentionDays: 90,
};
